import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .integration-status {
    display: inline-flex;
    align-items: center;
    margin: 1em 0em 0em 0.375em;
  }

  .done-icon {
    font-size: 1.4em;
    color: ${colors.secondary.dark};
  }

  .close-icon {
    font-size: 1.4em;
    color: red;
  }

  .icon-span {
    padding-left: 6px;
    font-weight: bold;
    font-size: 1.1em;
  }

  .tooltip {
    padding-left: 6px;
  }

  .tooltip-icon {
    color: ${colors.primary.dark};
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/tray/style.js